export default "__VITE_ASSET__BtOr8ZMv__"